/*jshint esversion: 6 */
import axios from 'axios';
import * as funcs from "../utils/showFuncs.js";
import * as ppFuncs from "../utils/PageParagraphFuncs.js";

import apiRouteNames from "../API_routes/routeFuncs";
const templatesUrl = apiRouteNames.templateRoute;



const putErrorET = "Kuvamismustri uundamine ei õnnestunud. ";
const postErrorET = "Kuvamismustri lisamine ei õnnestunud. ";
const getErrorET = "Kuvamismustri pärimine ei õnnestunud. ";
const deleteErrorET = "Kuvamismustri kustutamine ei õnnestunud. ";

export function getAllTemplates(self) {
    axios.get( templatesUrl)
        .then(function (response) {
            var allTemplates = response.data;
            //console.log('GET getAllTemplates allTemplates', allTemplates);
            self.setState ({ templates: allTemplates });
        })
        .catch(function (error) {
            //console.log('GET PAGES error', error);
            funcs.showError(getErrorET + error);
        });
}


// WEBPACK FOOTER //
// ./src/Controllers/TemplateGetter.js